import styled from "styled-components"

import Animation from "./Animation"

const Target = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: ${(props) => props.theme.zIndex.animation};
`

const AnimationTarget = () => (
  <Target id="animation-target">
    <Animation />
  </Target>
)

export default AnimationTarget
